import { render, staticRenderFns } from "./Global-Modal.vue?vue&type=template&id=3999bbb8&scoped=true&"
import script from "./Global-Modal.vue?vue&type=script&lang=js&"
export * from "./Global-Modal.vue?vue&type=script&lang=js&"
import style0 from "./Global-Modal.vue?vue&type=style&index=0&id=3999bbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3999bbb8",
  null
  
)

export default component.exports